import { PropsWithChildren } from 'react';
import { ProtectionLevel } from '../types';
import { useSession } from '@common/hooks';
import { ProtectedRouteWrapper } from './ProtectedRouteWrapper';
import { getRedirectPathToLastAllowedGate } from '../redirects';
import { useProtectionLevels } from '@router/hooks';

interface PermissionGateProps extends PropsWithChildren {
    requiredProtectionLevel: ProtectionLevel;
}

export const PermissionGate = ({
    requiredProtectionLevel,
    children,
}: PermissionGateProps) => {
    const { protectionLevel } = useSession();
    const condition = useProtectionLevels(requiredProtectionLevel);

    const redirectPath = getRedirectPathToLastAllowedGate(
        protectionLevel,
        requiredProtectionLevel,
    );

    return (
        <ProtectedRouteWrapper
            condition={condition}
            redirectPath={redirectPath}
        >
            {children}
        </ProtectedRouteWrapper>
    );
};
